import isNil from 'lodash-es/isNil';
/**
 * Model for a wrestlers seedingCriteria.
 */
import { SeedingCriteria } from '@reg/shared/model/seeding-criteria.model';

export class WrestlerSeedingCriteria {
    public id: string = null;
    public numericValue: number = null;
    public seedingCriteria: SeedingCriteria = null;
    public wrestlerId: string = null;
    public eventId: string = null;

    public clone(): WrestlerSeedingCriteria {
        const clone: WrestlerSeedingCriteria = new WrestlerSeedingCriteria();
        clone.id = this.id;
        clone.seedingCriteria = this.seedingCriteria && this.seedingCriteria.clone();
        clone.wrestlerId = this.wrestlerId;
        clone.eventId = this.eventId;
        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'wrestlerSeedingCriteria';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.relationships = {};
        json.data.attributes.numericValue = isNil(this.numericValue) ?
            null : parseFloat(this.numericValue.toString());

        if (this.seedingCriteria) {
            json.data.relationships.seedingCriteria = {
                data: { type: 'seedingCriteria', id: this.seedingCriteria.id },
            };
        }

        return JSON.stringify(json);
    }

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: any, included: any[] = null): WrestlerSeedingCriteria {
        const data: any = json['data'] || json;
        const attrs: any = data['attributes'];
        const relationships: any[] = data['relationships'] || [];
        included = included || json.included;

        this.id = data.id;
        this.numericValue = attrs.numericValue !== null ? parseFloat(attrs.numericValue) : null;
        this.wrestlerId = attrs.wrestlerId;
        this.eventId = attrs.eventId;

        // Fill createdBySeedingCriteria from relationships if it exists
        const seedingCriteriaRelationship: Object = relationships['seedingCriteria'];
        if (seedingCriteriaRelationship &&
            included &&
            seedingCriteriaRelationship['data'] &&
            seedingCriteriaRelationship['data']['id']) {
            const seedingCriteriaId: string = seedingCriteriaRelationship['data']['id'];
            const seedingCriteriaInclude: Object =
                included.filter((i: Object) => i['type'] === 'seedingCriteria' && i['id'] === seedingCriteriaId)[0];

            if (seedingCriteriaInclude) {
                this.seedingCriteria = (new SeedingCriteria()).deserialize(seedingCriteriaInclude);
            }
        } else if (attrs['seedingCriteriaId']) {
            this.seedingCriteria = new SeedingCriteria(attrs['seedingCriteriaId'], false);
        }

        return this;
    }
}
